import React, {useCallback, useEffect, useRef, useState} from 'react'
import {observer} from 'mobx-react-lite'
import {useStoreDetailsStore} from '../../../../store/hooks/useStore'
import {StoreDetailResponseItem} from '../../../../types/store/storeDetails'
import {StoreMap} from '../../../../components/store-map'
import {Marker} from '../../../../components/store-map/marker'

interface StoreMapProps {
  selectedStoreId: string
  setSelectedStoreId: (id: string) => void
  mapOptions: {
    center: {
      lat: number
      lng: number
    }
    zoom: number
  }
}

export const StoreLocatorMap = observer(function StoreLocatorMap(props: StoreMapProps) {
  const {mapOptions, selectedStoreId, setSelectedStoreId} = props
  const {currentSearch} = useStoreDetailsStore()

  const mapRef = useRef<google.maps.Map | null>(null)

  const [markersPlaced, setMarkerPlaced] = useState<boolean>(false)

  const handleMarkerClick = (store: StoreDetailResponseItem) => {
    setSelectedStoreId(store.id)
  }

  const updateBounce = useCallback(() => {
    if (!mapRef.current) return

    if (currentSearch.length) {
      const bounds = new google.maps.LatLngBounds()

      for (const store of currentSearch) {
        bounds.extend({lat: store.latitude, lng: store.longitude})
      }

      mapRef.current.fitBounds(bounds)
    }
  }, [currentSearch])

  // Center selected store on the map
  useEffect(() => {
    if (!selectedStoreId || !mapRef.current) return
    if (markersPlaced && currentSearch) {
      const selectedStore = currentSearch?.find((store) => store.id === selectedStoreId)

      if (selectedStore)
        mapRef.current?.setCenter({lat: selectedStore.latitude, lng: selectedStore.longitude})
    }
  }, [selectedStoreId])

  return (
    <StoreMap
      updateBounce={updateBounce}
      mapOptions={mapOptions}
      onMarkerClick={handleMarkerClick}
      onSetMap={(gmap) => (mapRef.current = gmap)}
    >
      {currentSearch.map((store, idx) => {
        return (
          <Marker
            key={`marker-store-${store.id}`}
            selectedMarkerId={selectedStoreId}
            storeDetail={store}
            num={idx + 1}
            options={{
              position: {
                lat: store.latitude,
                lng: store.longitude,
              },
            }}
            setLastMarkerPlaced={() => {
              if (idx === currentSearch.length - 1) setMarkerPlaced(true)
            }}
          />
        )
      })}
    </StoreMap>
  )
})
